import "survey-core/survey-core.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import { SurveyCreatorComponent, SurveyCreator } from "survey-creator-react";
import { useParams } from 'react-router-dom';
import { StorageService } from '@/app/services/StorageService';
import { Stack, useToast } from '@chakra-ui/react';
import React from 'react';
import { parseJSON, stringifyError } from '@/shared/parse';
import { AppContext } from '@/app/comments/AppContext';
import { ErrorMessage } from '../components/ErrorMessage';
import { TEMPLATE } from '@/shared/constants';
import { SurveyService } from '../services/SurveyService';
import { AppBreadcrumb } from '../navbar/AppBreadcrumb';

const creatorOptions = {
  showLogicTab: true,
  isAutoSave: true
};

export const EditSurveyTemplatePage = () => {

  SurveyService.configure();

  const params = useParams<{ fileName: TEMPLATE }>();

  const creator = React.useRef<SurveyCreator>(new SurveyCreator(creatorOptions));
  const [isLoaded, setIsLoaded] = React.useState(false);

  const toast = useToast();

  const { setStatus } = React.useContext(AppContext);

  const [errorMessage, setErrorMessage] = React.useState('');

  React.useEffect(() => {
    if (params.fileName) {
      setIsLoaded(false);
      setStatus('Loading...');
      StorageService.getTemplateFile(params.fileName).then(json => {
        creator.current.applyCreatorTheme({
          cssVariables: {
            '--sjs-primary-background-500': '#034EA2', // --primary
            '--sjs-secondary-background-500': '#6bb745', // --secondary
            '--sjs-special-background': '#FCFDFE', // --background-dim
          }
        })
        creator.current.JSON = parseJSON(json);
        setIsLoaded(true);
      }, (err) => {
        setErrorMessage(err);
      }).finally(() => {
        setStatus(undefined);
      });
    }
  }, [params.fileName]);

  creator.current.saveSurveyFunc = (saveNo: any, callback: any) => {
    if (params.fileName) {
      const json = JSON.stringify(creator.current.JSON, null, 2);
      StorageService.putTemplateFile(params.fileName, json).then(() => {
        callback(saveNo, true);
      }, (err) => {
        toast({
          title: `Unable to save the template for module ${params.fileName}`,
          description: stringifyError(err),
          status: 'error',
          duration: 5000,
          isClosable: true
        });
        callback(saveNo, false);
      });
    } else {
      callback(saveNo, false);
    }
  };

  const breadcrumb = React.useMemo(() => [
    { href: `/admin`, label: 'Admin' },
    { href: `/admin/template`, label: 'Templates' },
    { href: `/admin/template/${params.fileName}`, label: params.fileName },
  ], [params.fileName]);

  return <>
    <AppBreadcrumb breadcrumb={breadcrumb} />
    <Stack mt='110px' height='calc(100vh - 120px)' p='4' borderWidth='1px' borderColor='gray.200'>
      <ErrorMessage error={errorMessage} />
      {isLoaded && <SurveyCreatorComponent creator={creator.current} />}
    </Stack>
  </>

};